import { useApplication } from "../context/ApplicationContext";

export default function ApplicationSelectors() {
  const app = useApplication();
  return <div className="application-selectors flex min-w-0 items-center gap-1.5 text-xs">
    <label className="sr-only" htmlFor="organisation-selector">Organisation</label>
    {app.organisations.length > 1 ? <select id="organisation-selector" value={app.activeOrganisationId || ""} disabled={app.contextLoading}
      onChange={(event) => app.switchOrganisation(event.target.value)} className="organisation-context brand-selector h-10 min-w-0 max-w-40 truncate rounded-md border border-gray-300 bg-white px-2 py-1">
      {app.organisations.map((org) => <option key={org.id} value={org.id}>{org.name}</option>)}
    </select> : <span className="organisation-context max-w-32 truncate font-semibold">{app.activeOrganisation?.name}</span>}
    <label className="sr-only" htmlFor="site-selector">Site context</label>
    <select id="site-selector" value={app.activeSiteId || ""} disabled={app.contextLoading} onChange={(event) => app.switchSite(event.target.value || null)}
      className="site-context brand-selector h-10 min-w-0 max-w-40 truncate rounded-md border border-gray-300 bg-white px-2 py-1">
      <option value="">All authorised Sites</option>
      {app.sites.map((site) => <option key={site.id} value={site.id}>{site.name}</option>)}
    </select>
  </div>;
}
